import { render, staticRenderFns } from "./GameDefaultListTem.vue?vue&type=template&id=f0a1dd08&scoped=true"
import script from "./GameDefaultListTem.vue?vue&type=script&lang=js"
export * from "./GameDefaultListTem.vue?vue&type=script&lang=js"
import style0 from "./GameDefaultListTem.vue?vue&type=style&index=0&id=f0a1dd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a1dd08",
  null
  
)

export default component.exports